import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { Box } from "@gemini/core";
import { Avatar } from "@gemini/ui";
import { useBrandUrl } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { useMapContext } from "@/domains/map";
import { MAP_STYLES } from "../../../constants";
export const mapStylePickerTestId = "cdp-location-map-style-picker";
export const MapStylePicker = () => {
    const { style, setStyle, setIs3DMode, is3DMode, setLayers, layers, setIsStyleLoaded, isStyleLoaded, } = useMapContext();
    const { t } = useI18n();
    const styleUrls = useBrandUrl({
        endpoint: "/shared/images/map",
    });
    const styleItems = [
        {
            label: t("location.map.modal.layer.default"),
            value: MAP_STYLES.STANDARD,
            src: `${styleUrls}/style-standard.png`,
        },
        {
            label: t("location.map.modal.layer.satellite"),
            value: MAP_STYLES.SATELLITE,
            src: `${styleUrls}/style-satellite.png`,
        },
        {
            label: "3D",
            value: MAP_STYLES.THREE_DIMENSIONAL,
            src: `${styleUrls}/style-three-dim.png`,
        },
    ];
    const handleStyleItemClick = (value) => {
        if (value === style)
            return;
        console.log("handlestyle change isStyleLoaded", isStyleLoaded);
        if (value === MAP_STYLES.THREE_DIMENSIONAL) {
            setStyle(value);
            if (style !== MAP_STYLES.STANDARD) {
                setIsStyleLoaded(false);
            }
            setIs3DMode(true);
            return;
        }
        if (value === MAP_STYLES.SATELLITE) {
            setLayers(Object.assign(Object.assign({}, layers), { sunlight: false }));
        }
        if (value === MAP_STYLES.STANDARD &&
            style === MAP_STYLES.THREE_DIMENSIONAL) {
            setIs3DMode(false);
            setStyle(value);
            return;
        }
        setIsStyleLoaded(false);
        setIs3DMode(false);
        setStyle(value);
    };
    useEffect(() => {
        if (is3DMode && style !== MAP_STYLES.THREE_DIMENSIONAL) {
            setStyle(MAP_STYLES.THREE_DIMENSIONAL);
        }
    }, [is3DMode, setStyle, style]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { as: "span", display: "block", typography: "typography.body.16.bold", marginBottom: "spacing.16", children: t("location.map.modal.layer.map_type") }), _jsx(Box, { display: "flex", gap: "spacing.12", children: styleItems.map((styleItem) => {
                    const isActive = style === styleItem.value;
                    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.6", onClick: () => handleStyleItemClick(styleItem.value), cursor: "pointer", children: [_jsx(Box, { borderStyle: "solid", borderRadius: "radius.8", borderColor: isActive
                                    ? "color.border.constant.black"
                                    : "color.border.constant.white", testId: `${mapStylePickerTestId}.${styleItem.value}${isActive ? ".active" : ".inactive"}`, children: _jsx(Avatar, { label: t("location.map.modal.layer.avatar.aria_label", {
                                        replace: {
                                            map_style: styleItem.label,
                                        },
                                    }), imageUrl: styleItem.src, size: "64", hasPaddingDisabled: true }) }), _jsx(Box, { as: "span", typography: "typography.body.12.regular", children: styleItem.label })] }, styleItem.label));
                }) })] }));
};
